import { Modal } from './core';
import { Button } from './core';
import { useState } from 'react';
import { useCloseMonthUser } from '../graphql/hooks/useUserDashboard';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  monthLabel: string;
  hoursDiff: number;
  month: number;
  year: number;
  user_id?: string;
}

export function CloseMonthConfirmModal({
  isOpen,
  onClose,
  monthLabel,
  hoursDiff,
  month,
  year,
  user_id,
  
}: Props) {
  const [comment, setComment] = useState('');
   const { mutate: closeMonth } = useCloseMonthUser();

  const handleSave = () => {
    closeMonth(
      {
        month,
        year,
        comment,
        user_id,
      },
      {
        onSuccess: () => {
          onClose();
          setComment('');
        },
        onError: (err) => {
          console.error('Close month failed', err);
        },
      }
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      title={`Monat abschließen - ${monthLabel}`}
    >
      <div className="space-y-6">

        {/* Comment */}
        <div>
          <p className="text-[#6b6b6b] text-[14px] mb-2">
            Anmerkung
          </p>

          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="z.B. Überstundenauszahlung -10 Std"
            rows={4}
            className="w-full box-border px-4 py-3 border border-[#e0e0e0] rounded-[8px]"
          />
        </div>

        {/* Info Text */}
        <div className="text-[14px] text-[#374151]">
          Mit dem Monatsabschluss werden Ihnen{' '}
          <span
            className={`font-medium ${
              hoursDiff < 0 ? 'text-red-600' : 'text-green-600'
            }`}
          >
            {hoursDiff.toFixed(2)} Std
          </span>{' '}
          angerechnet
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 pt-4">
          <Button variant="secondary" onClick={onClose}>
            Schließen
          </Button>

          <Button
            variant="primary"
            onClick={handleSave}
          >
            Speichern
          </Button>
        </div>
      </div>
    </Modal>
  );
}